import React from 'react';
import { CustomPicker } from 'react-color';
import { EditableInput, Hue, Saturation } from 'react-color/lib/components/common';

class ColorPicker extends React.Component {
  setColor = (color) => {
    const { onChange } = this.props;
    onChange({hex: color});
  }

  renderColorPointer = () => <div className="colorpicker__pointer"></div>;

  resetColor = () => {
    const { defaultColor = 'transparent' } = this.props;
    this.setColor(defaultColor);
  };

  render() {
    const { hex, onChange, presetColors } = this.props;
    const clearedColor = hex === 'transparent' ? '' : hex.replace('#', '');
    return (
			<div className="colorpicker">
        <div className="colorpicker__visual">
          <div className="colorpicker__saturation">
            <Saturation
              {...this.props}
              onChange={onChange}  />
          </div>
          <div className="colorpicker__hue">
            <Hue
              {...this.props}
              onChange={onChange}
              pointer={this.renderColorPointer}
              direction={'vertical'} />
          </div>
        </div>
        <div className="colorpicker__inputs">
          <div className="input-group">
            <div className="input-group-btn">
              <button className="btn btn-form" disabled="disabled">#</button>
            </div>
            <EditableInput
              label="hex"
              hideLabel={true}
              placeholder="FFF"
              value={clearedColor}
              onChange={onChange} />
            <div className="input-group-btn">
              <div className="btn btn-form colorpicker__clear" onClick={this.resetColor}>
                <i className="fi fi-delete"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="colorpicker__preset-colors">
          {presetColors.map((color, index) => (
            <div style={{backgroundColor: color}}
              key={`presetr-${index}`}
              onClick={() => this.setColor(color)}></div>
          ))}
        </div>
			</div>
    );
  }
}

export default CustomPicker(ColorPicker);
